import { ItemCategory } from "@/domains/inventory/constants/itemCategory";

export const itemCategoryTranslations: Record<ItemCategory, string> = {
  [ItemCategory.Weapon]: "Оружие",
  [ItemCategory.WeaponComponents]: "Компоненты оружия",
  [ItemCategory.Products]: "Продукты",
  [ItemCategory.Tech]: "Техника",
  [ItemCategory.Clothes]: "Одежда",
  [ItemCategory.Med]: "Медикаменты",
  [ItemCategory.Resources]: "Ресурсы",
  [ItemCategory.Capacity]: "Ёмкости",
  [ItemCategory.Quest]: "Квестовые",
};
